import _ from 'lodash';

export function parseScrapeData(scrapeData) {
  const parsedSite = {
    pluginCount: 0,
    updatesRequired: 0,
    wpVersion: null,
    updatedAt: null,
    wpUpdateVersionFound: false,
    wpUpdateVersionLocale: null,
    phpVersion: null,
    mysqlVersion: null,
    appPluginUpdateAvailable: true,
    siteInfo: {},
    themeData: {
      currentTheme: {},
      installedThemes: [],
    },
  };
  if (!scrapeData) {
    return parsedSite;
  }

  parsedSite.pluginCount = scrapeData.pluginData.length;
  scrapeData.pluginData.forEach((plugin) => {
    if (plugin.updateFound) {
      parsedSite.updatesRequired++;
    }
  });

  // Check if app plugin update is available
  if (_.has(scrapeData, 'appPluginUpdateAvailable')) {
    parsedSite.appPluginUpdateAvailable = _.get(scrapeData, 'appPluginUpdateAvailable', true);
  }

  if (scrapeData.wpData) {
    parsedSite.wpVersion = scrapeData.wpData.version_checked;

    // If it could not be found in the normal place, then the global version supplied in the plugin. Not all hosts
    // returns WP version data in the same way. Note that if this method is used, we cannot do WP core updates, as we
    // don't have the link to the latest WP version available.
    if (!parsedSite.wpVersion) {
      parsedSite.wpVersion = _.get(scrapeData, 'wpData.globalWpVersion', null);
    }

    parsedSite.phpVersion = _.get(scrapeData, 'wpData.phpVersion', null);
    parsedSite.mysqlVersion = _.get(scrapeData, 'wpData.mysqlVersion', null);

    const wpUpdates = _.get(scrapeData.wpData, 'updates', []);

    if (wpUpdates.length) {
      const wpVersionUpdate = _.find(wpUpdates, { response: 'upgrade' });
      parsedSite.wpUpdateVersionFound = _.get(wpVersionUpdate, 'version', false);
      parsedSite.wpUpdateVersionLocale = _.get(wpVersionUpdate, 'locale', null);
    }
  }

  // Site info
  if (scrapeData.siteInfo) {
    if (scrapeData.siteInfo.blogname !== undefined) {
      parsedSite.siteInfo = {
        name: scrapeData.siteInfo.blogname,
      };
    }
  }

  // Theme data
  if (scrapeData.themeData) {
    parsedSite.themeData = scrapeData.themeData;
    parsedSite.currentTheme = _.find(scrapeData.themeData.installed_themes, { active: true }, {});
    parsedSite.installedThemes = _.orderBy(_.get(scrapeData.themeData, 'installed_themes', []), ['name', 'asc']);
  }

  // Last update
  parsedSite.updatedAt = scrapeData.updatedAt;

  parsedSite.scrapeData = scrapeData;
  return parsedSite;
}
